import {Injectable} from "@angular/core";
import {DeactivateDialogComponent} from "./deactivate-dialog/deactivate-dialog.component";

@Injectable({providedIn: 'root'})
export class DeactivateDialogService {

  // Component is added once globally in the AppComponent
  private deactivateDialog: DeactivateDialogComponent | undefined;

  public setDeactivateDialog(deactivateDialog: DeactivateDialogComponent): void {
    this.deactivateDialog = deactivateDialog;
  }

  public openLeave(): Promise<boolean> {
    return this.deactivateDialog!.openLeave();
  }

  // noinspection JSUnusedGlobalSymbols
  public openWait(): void {
    this.deactivateDialog!.openWait();
  }

  public close(): void {
    this.deactivateDialog!.close();
  }

  public isOpen():boolean{
    return this.deactivateDialog!.isOpen();
  }

  public isClosed():boolean {
    return !this.isOpen();
  }
}
